<template>
  <v-layout>
    <filtersMaster ref="filtersMaster" :select="select" :filtersdef="filtros" :options="options" @filter="filter" @loadSelectsData="loadSelectsData" />
    <v-layout column right floating class="fab-container" style="z-index: 1">
      <v-btn
        v-if="$userPermission.hasPermission('ROLE_MODIFICAR_MSSCAM')"
        color="primary"
        fab
        small
        dark
        :title="$t('view.operativos.campana.massupdate.button')"
        class="btn_tippy_menu mt-1"
        @click="massupdate">
        <v-icon small>fas fa-reply-all</v-icon>
      </v-btn>
    </v-layout>
  </v-layout>
</template>
<script>
import FiltersMaster from "@/components/datatable/Filters"; /** *******************************/
import tippy from "tippy.js";
import CombosAPI from "@/services/catalogos";
import { SE_NEGOCIO_SELECT } from "@/constants/operativos";

export default {
  name: "FiltersModule"
  , components: { FiltersMaster }
  , emits: ["filter", "massupdate"]
  , data() {
    return {
      init: true
      , view: { action: { submit: { busy: false } } }
      , select: {
        negocio: {
          completeList: SE_NEGOCIO_SELECT
          , filteredList: SE_NEGOCIO_SELECT
          , disabled: false
        }
        , vendor: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
      }
      , filtros: {
        campana: []
        , se: []
        , seller: []
        , storeid: []
        , negocio: []
        , vendor: []
        , status: []
        , dateres: []
        , datelim: []
        , oob: []
      }
      , options: [
        {
          code: "campana"
          , name: this.$t("view.operativos.campana.filters.campana")
          , icon: "fas fa-bullhorn"
          , type: "multitext"
          , selected: ""
          , disabled: false
        }
        , {
          code: "se"
          , name: this.$t("view.operativos.campana.filters.se")
          , icon: "fas fa-sort-numeric-down"
          , type: "multinumber"
          , selected: ""
          , disabled: false
        }
        , {
          code: "seller"
          , name: this.$t("view.operativos.campana.filters.seller")
          , icon: "fas fa-sort-numeric-down"
          , type: "multitext"
          , selected: ""
          , disabled: false
        }
        , {
          code: "storeid"
          , name: this.$t("view.operativos.campana.filters.storeid")
          , icon: "fas fa-sort-numeric-down"
          , type: "multinumber"
          , selected: ""
          , disabled: false
        }
        , {
          code: "negocio"
          , name: this.$t("view.operativos.se.filters.negocio")
          , icon: "fas fa-check-circle"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "vendor"
          , name: this.$t("view.operativos.campana.filters.vendor")
          , icon: "fas fa-hand-holding-usd"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "status"
          , name: this.$t("view.operativos.campana.filters.status")
          , icon: "fas fa-check"
          , type: "sino"
          , selected: false
          , disabled: false
        }
        , {
          code: "dateres"
          , name: this.$t("view.operativos.campana.filters.dateres")
          , icon: "fas fa-calendar-check"
          , type: "date"
          , selected: { ini: "", end: "" }
          , disabled: false
        }
        , {
          code: "datelim"
          , name: this.$t("view.operativos.campana.filters.datelim")
          , icon: "fas fa-calendar-check"
          , type: "date"
          , selected: { ini: "", end: "" }
          , disabled: false
        }
        , {
          code: "oob"
          , name: this.$t("view.operativos.campana.filters.oob")
          , icon: "fas fa-check"
          , type: "sino"
          , selected: false
          , disabled: false
        }
      ]
    };
  }
  , created() {
    this.$nextTick(() => tippy(".btn_tippy_menu", { arrow: true, size: "large", animation: "scale", placement: "left" }));
  }
  , methods: {
    filter(filtros) {
      this.$emit("filter", filtros);
    }
    , async loading(status = false) {
      this.view.action.submit.busy = status;
    }
    , async loadSelectsData() {
      if (this.init) {
        this.loadSelectVendor();

        if (this.select.vendor.filteredList.length > 0) this.init = false;
      }
    }
    , async loadSelectVendor() {
      const { data: { results: { combo: vendorList } } } = await CombosAPI.get({ option: "vendor" });
      this.select.vendor.filteredList = vendorList || [];
      this.select.vendor.completeList = vendorList || [];
    }
    , massupdate() {
      this.$emit("massupdate");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fab-container {
  position: fixed;
  top: 110px;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/operativos/campana/Filters.vue